import { USER_CATEGORIES } from './CurrentDocument';


export default USER_CATEGORIES;